import { lightBlue } from '@synoptic/ui-kit/palette.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const navButton = style({
  cursor: 'pointer',
  width: 32,
  height: 32,
  borderRadius: space.s12,
  backgroundColor: themeVars.nav.collapseButton.background.idle,
  color: themeVars.nav.collapseButton.foreground.idle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${themeVars.nav.collapseButton.border.default}`,
  padding: 0,

  transitionDuration: '0.15s',
  transitionProperty: 'background-color, color, border, opacity',

  ':hover': {
    backgroundColor: themeVars.nav.collapseButton.background.hover,
  },
  ':active': {
    backgroundColor: themeVars.nav.collapseButton.background.active,
  },

  ':focus': {
    outline: 'none',
  },
  ':focus-visible': {
    outline: `2px solid ${lightBlue[500]}`,
    outlineOffset: '-1px',
  },

  ':disabled': {
    cursor: 'default',
    backgroundColor: themeVars.button.disabled.background,
    color: themeVars.button.disabled.foreground,
    borderColor: themeVars.nav.collapseButton.border.disabled,
  },

  selectors: {
    '&[data-collapsed="false"]': {
      transform: 'rotate(180deg)',
    },
  },
});
